import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import searchComponent from './search.component';

const searchModule = angular
  .module('search', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.search', {
      url: '/search?terms&tags&categories',
      reloadOnSearch: false,
      resolve: {
        categories: (ApiService) => ApiService.taxonomy('categories'),
      },
      views: {
        content: {
          component: 'search',
        },
      },
    });
  })

  .component('search', searchComponent);

export default searchModule;
